import DriverNotificationApi from "../../services/api/DriverNotification";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in driver notifications actions :", err);
}

export const resetToInitialState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE,
    payload,
  };
};

export const resetState = (state) => async (dispatch) => {
  let payload = {
    state: state,
  };
  dispatch(resetToInitialState(payload));
};

export const setScheduledNotificationsList = (payload) => {
  return {
    type: ActionTypes.SET_SCHEDULED_NOTIFICATIONS_LIST,
    payload,
  };
};

export const setActiveCampaign = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_CAMPAIGN,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_DRIVER_NOTIFICATION,
    payload,
  };
};

export const setNewCampaignOptions = (payload) => {
  return {
    type: ActionTypes.SET_NEW_CAMPAIGN_OPTIONS,
    payload,
  };
};
export const removeLastEvaluatedKeyFromList = () => {
  return {
    type: ActionTypes.REMOVE_LAST_EVALUATED_KEY_FROM_LIST,
  };
}
export const emptyEvaluatedKeyList = () => {
    return {
        type: ActionTypes.EMPTY_LAST_EVALUATED_KEY_LIST,
    };
}
export const updateEvaluationKeyList = () => {
  return async (dispatch) => {
    dispatch(removeLastEvaluatedKeyFromList());
  }
}
export const clearEvaluatedKeyList = () => {
    return async (dispatch) => {
        dispatch(emptyEvaluatedKeyList());
    }
}
export const getScheduledNotificationsList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let body = {
        page_request: pageRequest,
        ...filters,
      };
      dispatch(setLoader(true));
      let response = await DriverNotificationApi.getScheduledNotificationsList(
        body
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setScheduledNotificationsList(response));
        dispatch(setActiveFilters(filters));
        if (Object.keys(filters).length === 0) {
          dispatch(resetState("activeFilters"));
        }
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getActiveCampaign =
  (campaign_id, language_id = "") =>
  async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response = await DriverNotificationApi.getActiveCampaign(
        campaign_id,
        language_id
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setActiveCampaign(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getNewCampaignOptions = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverNotificationApi.getNewCampaignOptions();
    dispatch(setLoader(false));
    if (response) {
      dispatch(setNewCampaignOptions(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const driverSelectionCSVUpload = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverNotificationApi.driverSelectionCSVUpload(
      payload
    );
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};

export const uploadCampaignImage = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverNotificationApi.uploadCampaignImage(payload);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};

export const createCampaign = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    if (payload.scheduled_time != "") {
      let date = new Date(payload.scheduled_time);
      payload.scheduled_time = date.toISOString();
    }
    if (payload.expiry_time != "") {
      let date = new Date(payload.expiry_time);
      payload.expiry_time = date.toISOString();
    }

    let response = await DriverNotificationApi.createCampaign(payload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.CREATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const editCampaign = (payload) => async (dispatch) => {
    try {
        dispatch(setLoader(true));
        let response = await DriverNotificationApi.editCampaign(payload);
        dispatch(setLoader(false));
        if (response) {
        dispatch(
            setStatus({
            type: "success",
            message: SuccessMessages.UPDATION_SUCCESS,
            })
        );
        }
        return response;
    } catch (err) {
        dispatch(setLoader(false));
        dispatch(
        setStatus({
            type: "error",
            message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
        );
        handleError(err);
    }
}
